<template>
  <div class="container-fluid page-container">
    <div class="row page-header__container mb-4 pb-3">
      <page-heading :class="'col-12'" :title="pageTitle" />
    </div>
    <b-card-body class="row m-auto col-md-12 p-3 p-sm-5 shadow rounded d-block" v-html="pageContent" />
  </div>
</template>

<script>
import PageHeading from "@/components/control/PageHeading";
import company from "@/imports/mixins/company";

export default {
  name: "Cookies",
  components: { PageHeading },
  mixins:[company],
  data() {
    return {
      contentKey: 'cookies',
      pageContent: null,
      pageTitle: 'Cookies',
    }
  },
  methods: {
    getPageContent() {
      const communicationsLanguage = this.company?.communications_language?.iso_code ?? 'en';
      this.$api.page.getPageContent(communicationsLanguage).then((response) => {
        const responseData = response.data;
        let content = responseData.find(page => page.url === this.contentKey);
        this.pageTitle = content.title;
        this.pageContent = content.body;
      });
    }
  },
  mounted() {
    this.getPageContent();
  }
}
</script>

<style scoped>

</style>
